<template>
    <div class="organization-ranking-wrapper row row-sm-column">
        <div class="card card--with-heading col-6 col-sm-12">
            <h4 class="card-header">
                <div class="card-title">Empresas con más operaciones</div>
                <div class="content-at-right">
                    <OrganizationRankingFastFilter
                        @organizationRankingFilterChange="
                            OnOrganizationRankingFilterChange($event)
                        "
                    />
                </div>
            </h4>

            <div class="full-size row row-sm-column">
                <div class="col-6 col-sm-12 separation-line">
                    <OrganizationRankingTable
                        tableFor="top5"
                        organizationType="buyer"
                        :fastFilter="fastFilterDate"
                    />
                </div>
                <div class="col-6 col-sm-12 second-table">
                    <OrganizationRankingTable
                        tableFor="top5"
                        organizationType="seller"
                        :fastFilter="fastFilterDate"
                    />
                </div>
            </div>
        </div>

        <div class="card card--with-heading col-6 col-sm-12">
            <h4 class="card-header">
                <div class="card-title">Últimas empresas que operaron</div>
            </h4>
            <div class="full-size row row-sm-column">
                <div class="col-6 col-sm-12 separation-line">
                    <OrganizationRankingTable
                        tableFor="recent"
                        organizationType="buyer"
                    />
                </div>
                <div class="col-6 col-sm-12 second-table">
                    <OrganizationRankingTable
                        tableFor="recent"
                        organizationType="seller"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrganizationRankingTable from "./OrganizationRankingTable.vue";
import OrganizationRankingFastFilter from "./OrganizationRankingFastFilter.vue";
export default {
    components: {
        OrganizationRankingTable,
        OrganizationRankingFastFilter,
    },
    data() {
        return {
            fastFilterDate: "last_3_months",
        };
    },
    methods: {
        OnOrganizationRankingFilterChange(filterDate) {
            this.fastFilterDate = filterDate;
        },
    },
};
</script>

<style scoped>

@media (max-width: 991px) {
    .second-table {
        padding-top: 0px
    }
}

.organization-ranking-wrapper {
    margin: 25px 0;
}
.card {
    margin: 10px 10px 0px 0px;
}

.full-size {
    width: 100%;
}
.card-header {
    min-height: 60px;
}

@media (max-width: 1350px) {
    .card-header {
        min-height: 82px;
    }
}

.content-at-right {
    text-align: right;
    margin-left: auto;
    z-index: 1;
}

.separation-line {
    border-right-width: 5px;
    border-right-style: solid;
    border-color: transparent #DCDCDC;
}
</style>